
export interface ICountByDay {
  day_ts: number
  count: number
  unique: number
}

export interface ISummary {
  cnt: number
  unique: number
  day_ts_min: number
}

export interface IStats {

  days: Array<ICountByDay>
  summary: ISummary
}